import { Space, Typography } from "antd";
import moment from "moment";
import { useIntl } from "react-intl";
import { getTaskRejectReason } from "utils/getTaskRejectReason";
import { DATE_FORMAT, TIME_FORMAT } from "~app/constants";
import { PageTitle } from "./PageTitle";
import { TaskStatusTag } from "./TaskStatusTag";

type Props = {
  isLoading: boolean;
  fixture: any;
};

export const FixtureTitle = ({ isLoading, fixture }: Props) => {
  const { formatMessage } = useIntl();

  const notDefined = formatMessage({ id: "notDefined" });
  const homeEntityName = fixture?.homeEntity?.nameLocal ?? notDefined;
  const awayEntityName = fixture?.awayEntity?.nameLocal ?? notDefined;
  const dateString = fixture?.startDateTimeLocal ? moment(fixture?.startDateTimeLocal).format(DATE_FORMAT) : notDefined;
  const timeString = fixture?.startDateTimeLocal ? moment(fixture?.startDateTimeLocal).format(TIME_FORMAT) : notDefined;
  const venueName = fixture?.venue?.nameLocal ?? notDefined;

  return (
    <PageTitle isLoading={isLoading}>
      <Space>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {formatMessage(
            { id: "fixturePage.title" },
            {
              homeEntityName,
              awayEntityName,
              venueName,
              date: dateString,
              time: timeString,
            }
          )}
        </Typography.Title>
        <TaskStatusTag status={fixture?.taskStatus} rejectReason={getTaskRejectReason(fixture)} />
      </Space>
    </PageTitle>
  );
};
